export const COLUMNS = [{
  slots: {
    title: '序号'
  },
  dataIndex: 'index',
  key: '1',
  align: 'center',
  width: 100,
  scopedSlots: {
    customRender: 'index'
  }
}, {
  slots: {
    title: '统计机构'
  },
  dataIndex: 'organizationName',
  key: '2',
  align: 'center'
}, {
  slots: {
    title: '业务类型'
  },
  dataIndex: 'type',
  key: '3',
  align: 'center'
}, {
  slots: {
    title: '分保费'
  },
  dataIndex: 'premium',
  key: '4',
  align: 'center'
}, {
  slots: {
    title: '应付保费'
  },
  dataIndex: 'premium2',
  key: '5',
  align: 'center'
}, {
  slots: {
    title: '分保佣金'
  },
  dataIndex: 'premium3',
  key: '6',
  align: 'center'
}];
export const data = [{
  organizationName: '泛华保险服务集团',
  type: '临时分保',
  premium: '20',
  premium2: '50',
  premium3: '5',
  id: '1'
}, {
  organizationName: '泛华保险服务集团',
  type: '合同分保',
  premium: '20',
  premium2: '50',
  premium3: '5',
  id: '2'
}];